(function ($) {

    "use strict";

    // Initialize Plugins
    if ($('.select').length) {
        $('.select').niceSelect();
    }

    // Responsive Menu
    $('.responsive').on('click', () => {
        $('#mobile-menu').slideToggle();
    });

    // Meanmenu
    if ($('#mobile-menu').length) {
        $('#mobile-menu').meanmenu({
            meanMenuContainer: '.mobile-menu',
            meanScreenWidth: "992"
        });
    }

    // Discount Bar Close
    $('.discount-close').on('click', () => {
        $('.discount-bar').addClass('d-none');
    });

    // Mobile Menu Item Click
    $(".main-menu li a").on('click', () => {
        if ($(window).width() < 700) {
            $("#mobile-menu").slideUp();
        }
    });

    // Coupon Toggle
    $('.coupon-click').on("click", () => {
        $('.coupon-form').slideToggle().toggleClass('caupon-area');
    });

    // Sticky Header
    if ($(".header-style-1, .header-style-3").length) {
        const header = document.getElementById("header-sticky");
        const pageWrap = document.querySelector('.page-wrap');
        const stickyPosition = header.offsetTop + header.offsetHeight;

        window.addEventListener('scroll', () => {
            if (window.pageYOffset > stickyPosition) {
                header.classList.add("sticky");
                if (pageWrap) pageWrap.style.marginTop = `${header.offsetHeight}px`;
            } else {
                header.classList.remove("sticky");
                if (pageWrap) pageWrap.style.marginTop = "0px";
            }
        });
    }

    // Header Category Toggle
    if ($(".header-category-item").length) {
        const headershopToggleBtn = $(".header-category-toggle-btn");
        const headershopContent = $(".category-shop-item");
        const headershopCloseBtn = $(".category-shop-close");
        const body = $("body");

        headershopToggleBtn.on("click", (e) => {
            headershopContent.toggleClass("category-shop-item-toggle");
            e.stopPropagation();
        });

        headershopCloseBtn.on("click", (e) => {
            headershopContent.removeClass("category-shop-item-toggle");
            e.stopPropagation();
        });

        body.on("click", () => headershopContent.removeClass("category-shop-item-toggle"));
        headershopContent.on("click", (e) => e.stopPropagation());
    }

    // Metis Menu
    if ($('#metis-menu').length) {
        $('#metis-menu').metisMenu().show();
    }

    // Tooltips
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    const tooltipList = tooltipTriggerList.map(el => new bootstrap.Tooltip(el));

    // WOW Animation
    const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
    });

    /*------------------------------------------
        = HIDE PRELOADER
    -------------------------------------------*/
    function preloader() {
        if ($('.preloader').length) {
            $('.preloader').delay(100).fadeOut(500, function () {

                //active wow
                wow.init();

            });
        }
    }


    // Back To Top Button
    $("body").append("<a href='#' class='back-btn'><i class='icon-angale-right2'></i></a>");

    const toggleBackToTopBtn = () => {
        if ($(window).scrollTop() > 1000) $("a.back-btn").fadeIn("slow");
        else $("a.back-btn").fadeOut("slow");
    };

    $(".back-btn").on("click", () => {
        $("html,body").animate({ scrollTop: 0 }, 700);
        return false;
    });

    $(window).on("scroll", toggleBackToTopBtn);

    // Hover Active Case
    const rightItems = document.querySelectorAll('.case-right-items .item');
    const leftItems = document.querySelectorAll('.case-left-image-group .img-item');

    rightItems.forEach((rightItem, index) => {
        rightItem.addEventListener('mouseenter', () => handleHover(rightItem, leftItems[index]));
    });

    const handleHover = (rightItem, leftItem) => {
        rightItems.forEach(item => item.classList.remove('active'));
        leftItems.forEach(item => item.classList.remove('active'));
        rightItem.classList.add('active');
        leftItem.classList.add('active');
    };

    // Owl Carousel Sliders
    const initOwl = (selector, options) => {
        if ($(selector).length) $(selector).owlCarousel(options);
    };

    initOwl(".featured-category-slider-active", {
        autoplay: false,
        smartSpeed: 300,
        margin: 20,
        loop: true,
        autoplayHoverPause: true,
        dots: true,
        nav: false,
        responsive: {
            0: { items: 1 },
            350: { items: 2 },
            500: { items: 3 },
            768: { items: 4 },
            992: { items: 5 },
            1200: { items: 6 },
            1400: { items: 6 }
        }
    });

    initOwl(".featured-category-slider-active-s2", {
        autoplay: true,
        smartSpeed: 1000,
        margin: 20,
        loop: true,
        autoplayHoverPause: true,
        dots: false,
        nav: false,
        responsive: {
            0: { items: 1 },
            350: { items: 1 },
            400: { items: 2 },
            500: { items: 2 },
            600: { items: 3 },
            768: { items: 4 },
            992: { items: 5 },
            1200: { items: 6 },
            1400: { items: 7 }
        }
    });

    initOwl(".deal-active", {
        autoplay: false,
        smartSpeed: 300,
        margin: 20,
        loop: true,
        autoplayHoverPause: true,
        dots: true,
        nav: false,
        responsive: {
            0: { items: 1 },
            768: { items: 1 },
            992: { items: 2 },
            1400: { items: 2 }
        }
    });

    initOwl(".best-selling-active", {
        autoplay: false,
        smartSpeed: 1000,
        margin: 20,
        loop: true,
        autoplayHoverPause: true,
        dots: false,
        nav: true,
        navText: ['<i class="icon-angale-right"></i>', '<i class="icon-angale-right2"></i>'],
        responsive: {
            0: { items: 1 },
            450: { items: 1 },
            767: { items: 2 },
            992: { items: 1 },
            1200: { items: 2 }
        }
    });

    /*------------------------------------------
   = PARTNERS SLIDER
-------------------------------------------*/
    if ($(".partners-slider").length) {
        $(".partners-slider").owlCarousel({
            autoplay: true,
            smartSpeed: 300,
            margin: 0,
            loop: true,
            autoplayHoverPause: true,
            dots: false,
            nav: false,
            responsive: {
                0: { items: 2 },
                550: { items: 3 },
                992: { items: 4 },
                1200: { items: 5 }
            }
        });
    }

    /*------------------------------------------
       = TESTIMONIAL SLIDER
    -------------------------------------------*/
    if ($(".testimonial-active").length) {
        $(".testimonial-active").owlCarousel({
            autoplay: true,
            smartSpeed: 2000,
            margin: 0,
            loop: true,
            items: 1,
            autoplayHoverPause: true,
            dots: false,
            nav: false
        });
    }

    /*------------------------------------------
       = TOP SELLING SLIDERS
    -------------------------------------------*/
    const initTopSelling = (selector, options) => {
        if ($(selector).length) $(selector).owlCarousel(options);
    };

    initTopSelling(".top-selling-active", {
        autoplay: false,
        smartSpeed: 300,
        margin: 20,
        loop: true,
        autoplayHoverPause: true,
        dots: true,
        nav: false,
        navText: ['<i class="icon-angale-right"></i>', '<i class="icon-angale-right2"></i>'],
        responsive: {
            0: { items: 1 },
            500: { items: 2 },
            768: { items: 2 },
            992: { items: 2 },
            1400: { items: 3 }
        }
    });

    initTopSelling(".top-selling-active-s2", {
        autoplay: false,
        smartSpeed: 300,
        margin: 20,
        loop: true,
        autoplayHoverPause: true,
        dots: true,
        nav: false,
        navText: ['<i class="icon-angale-right"></i>', '<i class="icon-angale-right2"></i>'],
        responsive: {
            0: { items: 1 },
            500: { items: 2 },
            768: { items: 2 },
            992: { items: 2 },
            1400: { items: 4 }
        }
    });

    /*------------------------------------------
       = BEST SELLING SLIDER S2
    -------------------------------------------*/
    initTopSelling(".best-selling-active-s2", {
        autoplay: false,
        smartSpeed: 1000,
        margin: 20,
        loop: true,
        autoplayHoverPause: true,
        dots: false,
        nav: true,
        arrows: true,
        navText: ['<i class="icon-angale-right"></i>', '<i class="icon-angale-right2"></i>'],
        responsive: {
            0: { items: 1, dots: true },
            450: { items: 1, dots: true },
            767: { items: 2, dots: true },
            992: { items: 2 },
            1200: { items: 4 }
        }
    });

    /*------------------------------------------
       = INSTAGRAM SLIDER
    -------------------------------------------*/
    initTopSelling(".instagram-slider", {
        autoplay: true,
        smartSpeed: 300,
        margin: 6,
        loop: true,
        autoplayHoverPause: true,
        dots: false,
        nav: false,
        responsive: {
            0: { items: 1 },
            500: { items: 2 },
            600: { items: 3 },
            768: { items: 3 },
            991: { items: 3 },
            1200: { items: 4 },
            1400: { items: 6 }
        }
    });

    // Instagram popup
    $(document).ready(() => {
        $('.instagram-popup').magnificPopup({
            type: 'image',
            mainClass: 'mfp-with-zoom',
            gallery: { enabled: true },
            zoom: { enabled: true, duration: 300, easing: 'ease-in-out' }
        });
    });

    /*------------------------------------------
       = POPUP VIDEO
    -------------------------------------------*/
    if ($(".video-btn").length) {
        $(".video-btn").on("click", function (e) {
            e.preventDefault();
            $.fancybox({
                href: this.href,
                type: $(this).data("type"),
                title: this.title,
                helpers: {
                    title: { type: 'inside' },
                    media: {}
                },
                beforeShow: () => $(".fancybox-wrap").addClass("portfolio-fancybox")
            });
        });
    }

    /*------------------------------------------
       = FUNFACT COUNTER
    -------------------------------------------*/
    if ($(".odometer").length) {
        $('.odometer').appear();
        $(document.body).on('appear', '.odometer', () => {
            $(".odometer").each(function () {
                const countNumber = $(this).data("count");
                $(this).html(countNumber);
            });
        });
    }

    /*------------------------------------------
       = MASONRY GALLERY
    -------------------------------------------*/
    const masonryGridSetting = () => {
        if ($('.masonry-gallery').length) {
            const $grid = $('.masonry-gallery').masonry({
                itemSelector: '.grid-item',
                columnWidth: '.grid-item',
                percentPosition: true
            });

            $grid.imagesLoaded().progress(() => $grid.masonry('layout'));
        }
    };
    masonryGridSetting();

    /*------------------------------------------
       = CONTACT FORM
    -------------------------------------------*/
    const initContactForm = () => {
        const $form = $("#contact-form-mejor");
        if (!$form.length || typeof $.fn.validate === "undefined") return;

        $form.validate({
            rules: {
                name: { required: true, minlength: 2 },
                email: { required: true, email: true },
                phone: { required: true },
                subject: { required: true }
            },
            messages: {
                name: "Please enter your name.",
                email: { required: "Please enter your email.", email: "Enter a valid email." },
                phone: "Please enter your phone number.",
                subject: "Please select your contact subject."
            },
            submitHandler: (form) => {
                $.ajax({
                    type: "POST",
                    url: "mail-contact.php",
                    data: $(form).serialize(),
                    dataType: "json",
                    beforeSend: () => $("#loader").show(),
                    success: (response) => {
                        $("#loader").hide();
                        if (response.status === "success") {
                            $("#success").slideDown("slow").delay(3000).slideUp("slow");
                            form.reset();
                        } else {
                            $("#error").text(response.message || "Submission failed.")
                                .slideDown("slow").delay(3000).slideUp("slow");
                        }
                    },
                    error: () => {
                        $("#loader").hide();
                        $("#error").text("Server error. Please try again later.")
                            .slideDown("slow").delay(3000).slideUp("slow");
                    }
                });
                return false;
            }
        });
    };
    initContactForm();



    /*------------------------------------------
   = FUNCTION FORM SORTING GALLERY
-------------------------------------------*/
    const sortingGallery = () => {
        if ($(".sortable-gallery .products-filters").length) {
            const $container = $('.product-container');
            $container.isotope({
                filter: '*',
                animationOptions: {
                    duration: 750,
                    easing: 'linear',
                    queue: false,
                }
            });

            $(".products-filters li a").on("click", function () {
                $('.products-filters li .current').removeClass('current');
                $(this).addClass('current');
                const selector = $(this).attr('data-filter');
                $container.isotope({
                    filter: selector,
                    animationOptions: {
                        duration: 750,
                        easing: 'linear',
                        queue: false,
                    }
                });
                return false;
            });
        }
    };
    sortingGallery();

    /*--------------------------------------------------------
       = Price Slider
    ----------------------------------------------------------*/
    const $sliderRange = $('#sliderRange');

    if ($sliderRange.length > 0) {
        $sliderRange.slider({
            range: true,
            min: 0,
            max: 10000,
            values: [500, 10000],
            slide: (event, ui) => {
                $("#amount").html("$" + ui.values[0] + " - $" + ui.values[1]);
            }
        });
        $("#amount").html("$" + $sliderRange.slider("values", 0) + " - $" + $sliderRange.slider("values", 1));
    }

    /*-----------------------
       = Cart Plus Minus Button
    -------------------------*/
    $(".cart-plus-minus").append('<div class="dec qtybutton">-</div><div class="inc qtybutton">+</div>');
    $(".qtybutton").on("click", function () {
        const $button = $(this);
        const oldValue = parseFloat($button.parent().find("input").val());
        let newVal;

        if ($button.text() === "+") {
            newVal = oldValue + 1;
        } else {
            newVal = oldValue > 0 ? oldValue - 1 : 0;
        }

        $button.parent().find("input").val(newVal);
    });

    /*------------------------------------------
       = Single Product Gallery Slider
    -------------------------------------------*/
    const productGallary = () => {
        if ($('.product-active').length && $('.product-thumbnil-active').length) {

            const $sync1 = $(".product-active"),
                $sync2 = $(".product-thumbnil-active");
            let flag = false;
            const duration = 500;

            $sync1
                .owlCarousel({
                    items: 1,
                    margin: 0,
                    nav: false,
                    dots: false
                })
                .on('changed.owl.carousel', (e) => {
                    if (!flag) {
                        flag = true;
                        $sync2.trigger('to.owl.carousel', [e.item.index, duration, true]);
                        flag = false;
                    }
                });

            $sync2
                .owlCarousel({
                    margin: 10,
                    items: 4,
                    nav: false,
                    dots: false,
                    center: false,
                    responsive: {
                        0: { items: 2, autoWidth: false },
                        400: { items: 2, autoWidth: false },
                        500: { items: 2, center: false, autoWidth: false },
                        600: { items: 3, autoWidth: false },
                        1200: { items: 4, autoWidth: false }
                    }
                })
                .on('click', '.owl-item', function () {
                    $sync1.trigger('to.owl.carousel', [$(this).index(), duration, true]);
                })
                .on('changed.owl.carousel', (e) => {
                    if (!flag) {
                        flag = true;
                        $sync1.trigger('to.owl.carousel', [e.item.index, duration, true]);
                        flag = false;
                    }
                });
        }
    };

    productGallary();

    /*------------------------------------------
        = COUNTDOWN CLOCK
-------------------------------------------*/
    if ($("#clock").length) {
        $("#clock").countdown("2025/12/03", (event) => {
            const $this = $(event.target);
            $this.html(
                event.strftime(
                    '' +
                    '<div class="box"><div><div class="time">%D</div></div></div>' +
                    '<div class="box"><div><div class="time">%H</div></div></div>' +
                    '<div class="box"><div><div class="time">%M</div></div></div>' +
                    '<div class="box"><div><div class="time">%S</div></div></div>'
                )
            );
        });
    }

    /*------------------------------------------
            = COUNTDOWN CLOCK TWO
    -------------------------------------------*/
    if ($("#clock-s2, #clock-s3").length) {
        $("#clock-s2, #clock-s3").countdown("2025/12/03", (event) => {
            const $this = $(event.target);
            $this.html(
                event.strftime(
                    '' +
                    '<div class="box"><div><div class="time">%D</div> <span>Days</span> </div></div>' +
                    '<div class="box"><div><div class="time">%H</div> <span>Hours</span> </div></div>' +
                    '<div class="box"><div><div class="time">%M</div> <span>Mins</span> </div></div>' +
                    '<div class="box"><div><div class="time">%S</div> <span>Secs</span> </div></div>'
                )
            );
        });
    }

    $(document).ready(() => {
        initContactForm();
    });

    /*==========================================================================
        WHEN DOCUMENT LOADING
    ==========================================================================*/
    $(window).on("load", () => {
        preloader();
        sortingGallery();
    });

    /*==========================================================================
        WHEN WINDOW SCROLL
    ==========================================================================*/
    $(window).on("scroll", () => {
        toggleBackToTopBtn();
    });

})(window.jQuery);
